const getComponentLayout = component => {
    if (!component || !component.props) {
        return null;
    }
    if (window.dash_component_api !== undefined) {
        if (component.props.componentPath === undefined) {
            return null;
        }
        return window.dash_component_api.getLayout(
            component.props.componentPath
        );
    }
    return component.props._dashprivate_layout;
};

export default {
    getType: component => getComponentLayout(component)?.type,
    getProps: component => getComponentLayout(component)?.props,
};
